/*
 * Copyright (c) 2021, WSO2 Inc. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 Inc. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

export interface IOrganizationBillingDetails {
  organizationId?: string;
  name?: string | null;
  email?: string | null;
  phone?: string | null;
  address?: {
    line1?: string | null;
    line2?: string | null;
    city?: string | null;
    state?: string | null;
    postalCode?: string | null;
    country?: string | null;
  } | null;
  billingProvider?: string;
  nameSplitIndex?: number;
}

export interface IUsageByService {
  name: string;
  value: number;
}

export interface Usage {
  [key: string]: { usage: number; limit: number };
}

export interface IMonthlyExpenditure {
  month: string;
  expenditure: number;
}

export interface ILastWeekUsage {
  date: string;
  steps: number;
}

export enum CloudType {
  Choreo = 'choreo',
  Asgardeo = 'asgardeo',
  Bijira = 'bijira',
  Devant = 'devant',
  Default = 'default',
}

export enum SubscriptionChangeOperation {
  Upgrade = 'upgrade',
  Downgrade = 'downgrade',
  Cancel = 'cancel',
  CancelAzure = 'azure-subscription-cancel',
  ChangePlanAzure = 'azure-subscription-change-plan',
}

export interface IKeyValues {
  [attribute: string]: string | number;
}

export enum ChoreoSubscriptionType {
  ChoreoSubscription = 'choreo-subscription',
  ChoreoSupport = 'wso2-support',
  OldChoreoSupport = 'choreo-support',
}

export enum BijiraSubscriptionType {
  BijiraSubscription = 'bijira-subscription',
  BijiraSupport = 'wso2-support',
}

export enum DevantSubscriptionType {
  DevantSubscription = 'devant-subscription',
  DevantSupport = 'wso2-support',
}

export enum AsgardeoSubscriptionType {
  AsgardeoSubscription = 'asgardeo-subscription',
}

export interface IInvoiceInfo {
  basePrice: number;
  supportPrice?: number;
  discount: number;
}

export interface IBillingInfo {
  name: string;
  type: string;
}

export enum BusinessModel {
  B2C = 'B2C',
  B2B = 'B2B',
  B2E = 'B2E',
}

export enum BillingCycle {
  MONTHLY = 'Monthly',
  ANNUALLY = 'Yearly',
  OVERAGE = 'Overage',
}

export enum AsgardeoTier {
  FREE = 'Free',
  ESSENTIAL = 'Essentials',
  PROFESSIONAL = 'Professional',
  PAYG = 'PYG',
  PAYG_TRIAL = 'PYG-Trial',
  ENTERPRISE = 'Enterprise',
}

export enum AsgardeoSupportPlan {
  COMMUNITY = 'Community',
  STANDARD = 'Basic',
  ENTERPRISE = 'Enterprise',
}

export interface IComplexTierAttribute {
  value: string;
  info?: React.ReactNode;
}
